import { CommonsEnvironment } from '@infodata-group/inf-commons';

export const environment: CommonsEnvironment = {
  production: true,
  env: 'preprod',

  api: {
    apiEndPoint: '/api/',
    settingsApi: 'auth/settings',
  },
  app: {
    appName: 'Integrix Ticket',
    appVersion: '4.3.4',
    appVersionDate: '02/10/2026',
    defaultRoute: '',
    appId: 'cfb47637-ccfc-a9c2-a012-777aab224b2f',
    cache: 0,
    lang: ['fr'],
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-ticket.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
  },
  login: {
    loginRoute: 'login',
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
    defaultConnection: true,
  },
  portal: {
    api: 'auth/auth-portal',
    portalUri: 'https://preprod-portail.integrix.lu',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-ticket.svg',
    exportLogoPath: 'https://assets.integrix.lu/img/logos/integrix-ticket.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://changelogs.integrix.lu/api/versions?&WITH=product|=|WEB-TICKET',
    route: 'changelogs',
  },
};
